import React from 'react';
import ClientPhotoEditor from '../client/ClientPhotoEditor';
import { useWizard } from '../wizard/WizardContext';

const CropStep: React.FC = () => {
  const { state } = useWizard();

  return (
    <ClientPhotoEditor
      file={state.uploadedFile!}
      country={state.selectedCountry!}
    />
  );
};

export default CropStep;